import React from "react";

// import { Fade } from "react-awesome-reveal";
import { Typography, Box, Grid } from "@mui/material";
// import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import Image from "../components/image/Image";
import image1 from "../resources/images/landing-page/3.jpg";
import image2 from "../resources/images/landing-page/4.jpg";
import image3 from "../resources/images/landing-page/5.jpg";
const Section5 = (props) => {
  // const nowMediaQuery = props.nowMediaQuery;

  const Item = styled(Box)(({ theme }) => ({
    // backgroundColor: "#fff",
    // ...theme.typography.body2,
    // padding: theme.spacing(1),
    // textAlign: "center",
  }));

  return (
    <section className="section">
      <div className="contents">
        <Grid
          container
          direction="row"
          sx={{
            justifyContent: "space-between",
          }}
        >
          <Grid
            size={{ xs: 12, md: 4, lg: 4 }}
            display={"flex"}
            direction={"column"}
            justifyContent={"flex-start"}
            alignItems={"start"}
            mr={2}
          >
            <Item>
              <Typography
                variant="h5"
                textAlign={"left"}
                sx={{ m: 1 }}
                className="blue bold"
              >
                도시락 나눔
              </Typography>

              <Box
                display={"flex"}
                flexDirection={"column"}
                justifyContent={"space-between"}
                width={"400px"}
                border={"1px solid #EDEDED"}
                borderRadius={1}
              >
                <Typography
                  variant="h6"
                  sx={{ m: 2, color: "grey" }}
                  textAlign={"left"}
                >
                  무료 급식을 통해 취약 계층의 영양 부족을 해소하고, 건강 회복과
                  일상의 변화를 돕습니다.
                </Typography>
                <Box>
                  <Image
                    disabledEffect
                    alt={""}
                    src={image1}
                    ratio={"16/9"}
                    sx={{ borderRadius: 1 }}
                  />
                </Box>
              </Box>
            </Item>
          </Grid>
          <Grid
            size={{ xs: 12, md: 4, lg: 4 }}
            display={"flex"}
            direction={"column"}
            justifyContent={"flex-start"}
            alignItems={"start"}
            mr={2}
          >
            <Item>
              <Typography
                variant="h5"
                textAlign={"left"}
                sx={{ m: 1 }}
                className="blue bold"
              >
                대화 및 상담
              </Typography>

              <Box
                display={"flex"}
                flexDirection={"column"}
                justifyContent={"space-between"}
                width={"400px"}
                border={"1px solid #EDEDED"}
                borderRadius={1}
              >
                <Typography
                  variant="h6"
                  sx={{ m: 2, color: "grey" }}
                  textAlign={"left"}
                >
                  대화와 상담을 통해 위기 상황을 파악하고, 맞춤형 지원과 지역
                  자원 연계를 제공합니다.
                </Typography>
                <Image
                  disabledEffect
                  alt={""}
                  src={image2}
                  ratio={"16/9"}
                  sx={{ borderRadius: 1 }}
                />
              </Box>
            </Item>
          </Grid>
          <Grid
            display={"flex"}
            direction={"column"}
            justifyContent={"flex-start"}
            alignItems={"start"}
            size={{ xs: 12, md: 4, lg: 4 }}
          >
            <Typography
              variant="h5"
              textAlign={"left"}
              sx={{ m: 1 }}
              className="blue bold"
            >
              주민 공동체 지원
            </Typography>

            <Box
              display={"flex"}
              flexDirection={"column"}
              justifyContent={"space-between"}
              width={"400px"}
              border={"1px solid #EDEDED"}
              borderRadius={1}
            >
              <Typography
                variant="h6"
                sx={{ m: 2, color: "grey" }}
                textAlign={"left"}
              >
                자조 모임과 돌봄 조직을 통해 고립을 해소하고, 서로를 돕는
                공동체를 만들어갑니다.
              </Typography>
              <Image
                disabledEffect
                alt={""}
                src={image3}
                ratio={"16/9"}
                sx={{ borderRadius: 1 }}
              />
            </Box>
          </Grid>
        </Grid>
        {/* </Fade> */}
      </div>
    </section>
  );
};

export default Section5;
